import groq from 'groq'

export const header = groq`
 _type,
  title,
  "updatedAt": ^._updatedAt
`
